import type { ReactNode } from 'react';

interface BrowserChromeProps {
  url: string;
  dark?: boolean;
  children: ReactNode;
}

/**
 * BrowserChrome — tiny mock browser frame (dots + URL bar) used
 * as the outer shell for every "before" and "after" mockup.
 */
export default function BrowserChrome({ url, dark = false, children }: BrowserChromeProps) {
  return (
    <div className={`mock ${dark ? 'dark' : ''}`}>
      <div className="tabbar">
        <div className="dots">
          <span />
          <span />
          <span />
        </div>
        <div className="url">{url}</div>
      </div>
      <div className="mock-body">{children}</div>
    </div>
  );
}
